<template>
  <a-modal
      title="订单详情"
      :width="800"
      :visible="visible"
      @cancel="handleCancel"
  >
    <a-spin :spinning="loading">
      <a-descriptions bordered :column="2">
        <a-descriptions-item label="运单号">{{ detail.equickWBNo }}</a-descriptions-item>
        <a-descriptions-item label="标签号">{{ detail.lableNo }}</a-descriptions-item>
        <a-descriptions-item label="客户单号">{{ detail.customNo }}</a-descriptions-item>
        <a-descriptions-item label="订单状态">
          <a-tag :color="getStatusType(detail.orderStatus)"> {{ getStatusText(detail.orderStatus) }}</a-tag>
        </a-descriptions-item>
        <a-descriptions-item label="计费重量（kg）">{{ detail.whtFatWht }}</a-descriptions-item>
        <a-descriptions-item label="称重重量（kg）">{{ detail.whtWeightWht }}</a-descriptions-item>
        <a-descriptions-item label="财务总费用（USD）">{{ detail.totalArPostage }}</a-descriptions-item>
        <a-descriptions-item label="财务总费用（UZS）">{{ detail.totalArPostageUz }}</a-descriptions-item>
        <a-descriptions-item label="邮费（USD）">{{ detail.actuallyPostage }}</a-descriptions-item>
        <a-descriptions-item label="邮费（UZS）">{{ detail.actuallyPostageUz }}</a-descriptions-item>
        <a-descriptions-item label="其他费用（USD）">{{ detail.otherPostage }}</a-descriptions-item>
        <a-descriptions-item label="其他费用（UZS）">{{ detail.otherPostageUz }}</a-descriptions-item>
        <a-descriptions-item label="支付状态">
          <a-tag :color="detail.paymentStatus === 1 ? 'green' : 'orange'">
            {{ detail.paymentStatus === 1 ? '已支付' : '未支付' }}
          </a-tag>
        </a-descriptions-item>
        <a-descriptions-item label="应收金额（USD）">{{ detail.payableAmount }}</a-descriptions-item>
        <a-descriptions-item label="实收金额（UZS）">{{ detail.payAmount }}</a-descriptions-item>
        <a-descriptions-item label="积分优惠金额（UZS）">{{ detail.discountAmount }}</a-descriptions-item>
        <a-descriptions-item label="结算类型">
          {{ detail.settlemenType === 0 ? '寄付' : '到付' }}
        </a-descriptions-item>
        <a-descriptions-item label="包裹数量（个）">{{ detail.packageCount }}</a-descriptions-item>
        <a-descriptions-item label="商品数量（个）">{{ detail.goodsCount }}</a-descriptions-item>
        <a-descriptions-item label="运输类型">
          {{ detail.transportationType === 1 ? '空运' : '陆运' }}
        </a-descriptions-item>
        <a-descriptions-item label="商品品名" :span="2">{{ detail.goodsCategory }}</a-descriptions-item>
        <a-descriptions-item label="收件人姓名">{{ detail.consigneeName }}</a-descriptions-item>
        <a-descriptions-item label="收件人护照号">{{ detail.consigneeIdCard }}</a-descriptions-item>
        <a-descriptions-item label="收件人电话">{{ detail.consigneeMobile }}</a-descriptions-item>
        <a-descriptions-item label="收件人城市">{{ detail.consigneeCity }}</a-descriptions-item>
        <a-descriptions-item label="收件人地址" :span="2">{{ detail.consigneeAddress }}</a-descriptions-item>
        <a-descriptions-item label="自提站点" :span="2">{{ detail.siteName }}</a-descriptions-item>
        <a-descriptions-item label="站点城市" :span="2">{{ detail.siteCity }}</a-descriptions-item>
        <a-descriptions-item label="站点地址" :span="2">{{ detail.siteAddress }}</a-descriptions-item>
        <a-descriptions-item label="下单时间">{{ detail.orderTime }}</a-descriptions-item>
        <a-descriptions-item label="最后同步时间">{{ detail.lastPullTime }}</a-descriptions-item>
      </a-descriptions>
    </a-spin>
    <!-- 添加自定义footer -->
    <template #footer>
      <a-button key="close" type="primary" @click="handleCancel">关闭</a-button>
    </template>
  </a-modal>
</template>

<script>
import { getCustomerOrderDetail } from '@/api/customer'

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    orderId: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      loading: false,
      detail: {}
    }
  },
  watch: {
    orderId(val) {
      if (val) {
        this.loadDetail()
      }
    }
  },
  methods: {
    loadDetail() {
      this.loading = true
      const param = {
        id: this.orderId
      }
      getCustomerOrderDetail(param).then(response => {
        this.detail = response.data || {}
      }).finally(() => {
        this.loading = false
      })
    },
    handleCancel() {
      this.$emit('close')
    },
    getStatusText(status) {
      const statusMap = {
        0: '运输中',
        1: '待取件',
        2: '已签收',
        3: '异常',
        4: '已取消'
      }
      return statusMap[status] || '未知状态'
    },
    getStatusType(status) {
      const typeMap = {
        0: 'orange',
        1: 'cyan',
        2: 'green',
        3: 'red',
        4: 'purple'
      }
      return typeMap[status] || 'default'
    }
  }
}
</script>
